module.exports = __webpack_public_path__ + "img/applemusic.9d889503.svg";